var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"item"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.link}},[_c('i',{class:['tim-icons', 'font', _vm.icon]}),_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }